import React, { useEffect, useState } from 'react';
import './Admin.scss';
import axios from 'axios';  
import AdminNav from './AdminNav/AdminNav';

const Admin = () => {
  const [requests, setRequests] = useState([]);
  const [loggedIn, setLoggedIn] = useState(false);



// sets a timeout for auto logout after 15 minutes of inactivity
useEffect(() => {
  let logoutTimer;

  const resetTimer = () => {
    clearTimeout(logoutTimer);
    logoutTimer = setTimeout(() => {
      if (sessionStorage.getItem('isLoggedIn')) {
        handleLogout();
      }
    }, 15 * 60 * 1000); // 15 minutes
  };

  // List of events that indicate user activity
  const events = ['mousemove', 'keydown', 'click', 'scroll'];

  // Attach event listeners
  events.forEach(event =>
    window.addEventListener(event, resetTimer)
  );

  // Start the timer initially
  resetTimer();

  // Cleanup on component unmount
  return () => {
    events.forEach(event =>
      window.removeEventListener(event, resetTimer)
    );
    clearTimeout(logoutTimer);
  };
}, []);



  // Check if the user is logged in and redirect if not
  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem('isLoggedIn');
    setLoggedIn(isLoggedIn === 'true');

    if (!isLoggedIn) {
      alert('Unauthorized access. Please login first.');
      window.location.href = '/';
    }
  }, []);



  // Fetch mock data for requests
  useEffect(() => {
    const mockData = [
      {
        id: 1,
        firstName: 'Ritika',
        lastName: 'Majumdar',
        phone: '9876543210',
        email: 'ritika@example.com',
        service: 'Horoscope Match',
        date: '2025-07-24',
        orderid: 'ORD12345',
        PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
      {
        id: 2,
        firstName: 'Ayan',
        lastName: 'Das',
        phone: '9123456789',
        email: 'ayan@example.com',
        service: 'Birth Chart Reading',
        date: '2025-07-23',
        orderid: 'ORD12346',
        PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
      {
        id: 3,
        firstName: 'Puja',
        lastName: 'Roy',
        phone: '8912345670',
        email: 'puja@example.com',
        service: 'Kundli Analysis',
        date: '2025-07-22',
        orderid: 'ORD12347',
        PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
            {
        id: 4,
        firstName: 'Ritika',
        lastName: 'Majumdar',
        phone: '9876543210',
        email: 'ritika@example.com',
        service: 'Horoscope Match',
        date: '2025-07-24',
        orderid: 'ORD12345',
        PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
      {
        id: 5,
        firstName: 'Ayan',
        lastName: 'Das',
        phone: '9123456789',
        email: 'ayan@example.com',
        service: 'Birth Chart Reading',
        date: '2025-07-23',
        orderid: 'ORD12346',
                PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
      {
        id: 6,
        firstName: 'Puja',
        lastName: 'Roy',
        phone: '8912345670',
        email: 'puja@example.com',
        service: 'Kundli Analysis',
        date: '2025-07-22',
        orderid: 'ORD12347',
                PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
            {
        id: 7,
        firstName: 'Ritika',
        lastName: 'Majumdar',
        phone: '9876543210',
        email: 'ritika@example.com',
        service: 'Horoscope Match',
        date: '2025-07-24',
        orderid: 'ORD12345',
                PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
      {
        id: 8,
        firstName: 'Ayan',
        lastName: 'Das',
        phone: '9123456789',
        email: 'ayan@example.com',
        service: 'Birth Chart Reading',
        date: '2025-07-23',
        orderid: 'ORD12346',
                PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
      {
        id: 9,
        firstName: 'Puja',
        lastName: 'Roy',
        phone: '8912345670',
        email: 'puja@example.com',
        service: 'Kundli Analysis',
        date: '2025-07-22',
        orderid: 'ORD12347',
                PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
            {
        id: 10,
        firstName: 'Ritika',
        lastName: 'Majumdar',
        phone: '9876543210',
        email: 'ritika@example.com',
        service: 'Horoscope Match',
        date: '2025-07-24',
        orderid: 'ORD12345',
                PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
      {
        id: 11,
        firstName: 'Ayan',
        lastName: 'Das',
        phone: '9123456789',
        email: 'ayan@example.com',
        service: 'Birth Chart Reading',
        date: '2025-07-23',
        orderid: 'ORD12346',
                PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
      {
        id: 12,
        firstName: 'Puja',
        lastName: 'Roy',
        phone: '8912345670',
        email: 'puja@example.com',
        service: 'Kundli Analysis',
        date: '2025-07-22',
        orderid: 'ORD12347',
                PaymentStatus: 'Completed',
        ContactStatus: 'Incompleted',
      },
    ];

    setRequests(mockData);
  }, []);





    // Logout function to clear session and redirect to home without API call
  const logout = () => {
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.clear();
    window.location.href = '/';
  };


  
  // Handle logout with API call
const handleLogout = async () => {
  try {
    const res = await axios.get('https://core-c343.onrender.com/api/admin/logout');
    console.log(res.data.message);
    sessionStorage.clear();
    window.location.href = '/';
  } catch (err) {
    console.error('Logout error:', err);
  }
};



// Clear session storage on page unload or when the user tries to leave the page
useEffect(() => {
  const handleUnload = () => {
    navigator.sendBeacon('https://core-c343.onrender.com/api/admin/logout');
    sessionStorage.clear(); // Clear on frontend too
  };

  window.addEventListener('beforeunload', handleUnload);
  return () => window.removeEventListener('beforeunload', handleUnload);
}, []);





//gives a confirmation dialog when the user tries to leave the page
useEffect(() => {
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = ''; // required for Chrome to show confirmation dialog
  };

  // Prevent back button navigation
  window.history.pushState(null, null, window.location.href);
  const handlePopState = () => {
    window.history.pushState(null, null, window.location.href);
  };

  window.addEventListener('beforeunload', handleBeforeUnload);
  window.addEventListener('popstate', handlePopState);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    window.removeEventListener('popstate', handlePopState);
  };
}, []);


  return (
    <div className="admin-panel">
      <div className="header">
        <div className="adminNav">
        <AdminNav/>
        </div>
        {/* <h1>🔐 Admin Dashboard</h1> */}
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
      </div>

      <p>👤 Logged in as: {sessionStorage.getItem('username')} on {sessionStorage.getItem('loginDate')} at {sessionStorage.getItem('loginTime')}</p>

      <div className="request-table">
        <table>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Service</th>
              <th>Date</th>
              <th>Order ID</th>
              <th>Payment Status</th>
              <th>Contact Status</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((req) => (
              <tr key={req.id}>
                <td>{req.firstName}</td>
                <td>{req.lastName}</td>
                <td>{req.phone}</td>
                <td>{req.email}</td>
                <td>{req.service}</td>
                <td>{req.date}</td>
                <td>{req.orderid}</td>
                <td>{req.PaymentStatus}</td>
                <td>{req.ContactStatus}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Admin;
